import React, { useState } from "react";
import AccountingSoftwareButton from "./AccountingSoftwareButton";
import {
  accountingSoftwareConfig,
  filterAccountingSoftware
} from "../../../utils/constants/accountingSoftwareConfig";
import useQuickbooksApi from "../../../hooks/useQuickbooksApi";
import useMyobApi from "../../../hooks/useMyobApi";
import useReckonApi from "../../../hooks/useReckonApi";
import { accSoftwarePage } from "../../../locales/en";
import { XeroModal } from "../../../components/modals/XeroModal";
import PropTypes from "prop-types";

const AccountingSoftwareList = ({ softwareName = null }) => {
  const [showXeroModal, setShowXeroModal] = useState(false);
  const hooks = {
    quickbooks: useQuickbooksApi(),
    myob: useMyobApi(),
    reckon: useReckonApi()
  };

  let config = accountingSoftwareConfig(hooks, accSoftwarePage);

  config = filterAccountingSoftware(config, softwareName);

  const toggleXero = () => setShowXeroModal((prev) => !prev);

  return (
    <>
      <ul className="accounting-software-list">
        {config.map((item) => (
          <AccountingSoftwareButton
            key={item.id}
            {...item}
            onClickModal={
              item.id === accSoftwarePage?.xero ? toggleXero : undefined
            }
          />
        ))}
      </ul>

      <XeroModal isOpen={showXeroModal} toggle={toggleXero} />
    </>
  );
};

AccountingSoftwareList.propTypes = {
  softwareName: PropTypes.string
};

export default AccountingSoftwareList;
